import { NgIf, NgTemplateOutlet } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterLink } from '@angular/router';
import { UrlModule } from '@spartacus/core';
import { IconModule } from '@spartacus/storefront';
import { SdAddCompanyButtonComponent } from './add-company-button.component';

@NgModule({
  declarations: [SdAddCompanyButtonComponent],
  imports: [NgIf, NgTemplateOutlet, RouterLink, IconModule, UrlModule],
  exports: [SdAddCompanyButtonComponent],
})
export class SdAddCompanyButtonModule {}
